import { ActionIcon, Skeleton, Box } from "@mantine/core"
import { IconStar } from "@tabler/icons"
import { Auth0ContextInterface, useAuth0, User } from "@auth0/auth0-react";
import { useState } from "react";
import { saveIdeaStarred } from "../../../../Api";
import { useCurrentUser } from "../../../../hooks/useCurrentUser";

const StarCell: React.FC<any> = ({ data }) => {

  const auth0 = useAuth0();
  const currentUser = useCurrentUser();
  const [loadingStar, setLoadingStar] = useState([]);
  const [ideas, setIdeas] = useState<any[]>([]);
  const [starred, setstarred] = useState<boolean>(data?.starred &&
    auth0?.user &&
    data?.starred?.includes(currentUser?.id))

  const starClicked = (
    _id: string,
    bool: boolean,
    setLoadingStar: React.Dispatch<React.SetStateAction<any>>,
    idea: any,
    setIdeas: React.Dispatch<React.SetStateAction<any[]>>,
    auth0: Auth0ContextInterface<User>
  ) => {
    setLoadingStar((prev: any) => ({
      ...prev,
      [_id]: true,
    }));
    saveIdeaStarred(idea, auth0)
      .then(() => {
        setIdeas((prevState: any) => {
          const updated = prevState.map((item: any) => {
            if (item._id == _id) {
              const userId = currentUser?.id;
              return {
                ...item,
                starred: bool ? userId : false,
              };
            } else {
              return item;
            }
          });
  
          return updated;
        });
      })
      .catch(console.log)
      .finally(() =>{setLoadingStar((prev: any) => ({
        ...prev,
        [_id]: false,
      }))
      setstarred(!starred)
      }
        
      );
  };

  const  handleStarClicked = (_id: string, bool: boolean) => {
    /* setstarred(!setstarred) */
    starClicked(
      _id,
      bool,
      setLoadingStar,
      {
        id: _id,
        push: bool,
      },
      setIdeas,
      auth0,
      currentUser
    );
  };


  return (
    <ActionIcon loading={loadingStar[data?._id]} onClick={() => handleStarClicked(
      data._id,
      data.starred &&
          auth0.user &&
          data.starred?.includes(currentUser?.id)
        ? false
        : true
    )}>
      <IconStar
        color={
          starred
            ? "#FDAE1680"
            : "#D1D5DB"
        }
        fill={
          starred
            ? "#FDAE1680"
            : "#fff"
        }
        size={16}
        strokeWidth={2}
      />
    </ActionIcon>
  )
}

// Skeleton component for StarCell
export const StarCellSkeleton: React.FC<{ col: any }> = ({ col }) => {
  const columnWidth = col.width;
  const minWidth = col.minWidth;
  const maxWidth = col.maxWidth;
  
  return (
    <Box 
      sx={{ 
        width: columnWidth || "100%", 
        minWidth, 
        maxWidth,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Skeleton height={16} width={16} radius="sm" />
    </Box>
  );
};

export default StarCell

